/**
 * Hilfsfunktionen für die Kategoriefelder der Status-Formulare (hawk#606).
 */

/** Leere Eingabe → null (Legacy ohne Kategorie), sonst ganze Zahl. */
export function categoryValue(value: unknown): number | null {
  if (value === null || value === undefined || value === "") return null;
  const numeric = Number(value);
  return Number.isNaN(numeric) ? null : numeric;
}

/** Anzeigename wie im Backend: "3.0 erledigt", ohne Kategorie nur die Bezeichnung. */
export function statusPreviewLabel(values: { main_category?: unknown; sub_category?: unknown; name?: string }): string {
  const main = categoryValue(values?.main_category);
  const sub = categoryValue(values?.sub_category);
  const name = (values?.name ?? "").trim();
  if (main === null || sub === null) return name;
  return `${main}.${sub} ${name}`.trim();
}
